exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout[data-v-616209d0]{background:#f5f7f9;overflow:hidden}.layout-logo[data-v-616209d0]{width:150px;height:30px;float:left;position:relative;left:0;font-weight:700}.layout-nav[data-v-616209d0]{width:980px;margin:0 auto;margin-right:20px;float:right}.layout-footer-center[data-v-616209d0]{text-align:center;bottom:0}.ivu-layout-footer[data-v-616209d0]{padding:10px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-616209d0","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--1-1!./src/components/case/Index.vue
// module id = PE5C
// module chunks = 2